import React, {useContext} from 'react';
import About from './About'
import Projects from './Projects'
import Media from './Media'
import Contact from './Contact'

 
import {appContext} from '../contexts'

import {useHeaderChecker} from '../fn'

const Content = () => {
    const context = useContext(appContext)
    useHeaderChecker(context)



    const handleClick = () => {
        // console.log(context)
    }
    return ( 
        <main onClick={handleClick} onScroll={() => console.log("scrolling!")}>
            <About />
            <Projects />
            <Contact />
        </main>
     );
}
 
export default Content;